var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2302 17.2302C19.2229 15.2376 21.6589 13.7448 24.339 12.874C27.0191 12.0032 29.8673 11.779 32.6506 12.2199C35.434 12.6607 38.0735 13.754 40.3533 15.4104C42.6332 17.0668 44.4886 19.2393 45.768 21.7502C47.0473 24.2611 47.7143 27.0391 47.7143 29.8571C47.7143 32.6752 47.0473 35.4532 45.768 37.9641C44.4886 40.475 42.6332 42.6475 40.3533 44.3039C38.0735 45.9603 35.434 47.0536 32.6506 47.4944",
    stroke: "#3E4AE7",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.588c6c2670da95342903dfa49b930024.svg";
export { ForwardRef as ReactComponent };